/**
 * API Client Configuration
 * 
 * Configure the generated API client with the base URL and authentication
 */

import { OpenAPI } from './core/OpenAPI';
import {PLATFORM} from  '../config';

// Get base URL from environment or use default
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:2458';

/**
 * Initialize the API client configuration
 */
export function configureApiClient(config?: {
  baseUrl?: string;
  token?: string;
  sessionId?: string;
  apiKey?: string;
}) {
  OpenAPI.BASE = config?.baseUrl || API_BASE_URL;
  
  // Set up authentication token if provided
  if (config?.token) {
    OpenAPI.TOKEN = config.token;
  }
  
  // Set up custom headers for session and API key
  OpenAPI.HEADERS = {
    ...(config?.sessionId && { 'X-Session-Id': config.sessionId }),
    ...(config?.apiKey && { 'X-API-KEY': config.apiKey }),
  };
}

/**
 * Update session ID for all API requests
 */
export function setSessionId(sessionId: string) {
  let _session_id = sessionId;  
  if (!sessionId.startsWith(PLATFORM)) {
    //we need to tach the case where the sesison id is not set correctly
    console.warn(`Session ID "${sessionId}" does not start with expected platform prefix "${PLATFORM}". This may lead to authentication issues.`);  
    _session_id = PLATFORM.toLowerCase()+':'+sessionId;
  }


  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    'X-Session-Id': _session_id,
  };
  console.log(`Updated session ID to "${_session_id}"`);
}

/**
 * Update API key for all API requests
 */
export function setApiKey(apiKey: string) {
  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    'X-API-KEY': apiKey,
  };
}

/**
 * Set bearer token for authentication
 */
export function setAuthToken(token?: string | null) {
  OpenAPI.TOKEN = token ?? undefined;
}

export { OpenAPI };
